import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { Link, NavLink, useParams } from "react-router-dom";
import { handleDownloadOptions } from "../../Components/ExportData";

const AllRequests = () => {
    const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } = useContext(ConfigContext);
    const [selectOption, setSelectOption] = useState(null);
    const [rows, setRows] = useState([]);
    const { project_id } = useParams()
    const [status, setStatus] = useState(null);
    const [prev, setPrev] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [next, setNext] = useState(false);
    const [page, setPage] = useState(1);
    const [reload, setReload] = useState(false)
    // const [ItemRows, setItemRows] = useState([]);
    const [item_id, setItemId] = useState(0)
    const [item_row, setItemRow] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(null);
    const [price, setPrice] = useState("");
    const [quantity, setQuantity] = useState("");
    const [itemRemark, setItemRemark] = useState("");
    const [keyword, setKeyword] = useState("");
    const [projectData, setProjectData] = useState([]);
    const [projectId, setProjectId] = useState(0)
    const [formData, setFormData] = useState({
        title: "",
        consultant: "",
        project: "",
        contractor: "",
        submittalType: "",
        description: "",
        submittedBy: { name: "", position: "" },
        consultantRevision: "",
        attachments: [],
        approvalStatus: "",
        refNumber: "",
        title: "",
        revisionNumber: "",
        date: "",
        approvals: { name: "", position: "", date: "" },
        clearances: {
            electrical: false,
            architecture: false,
            civil: false,
            mechanical: false,
            digitalSignature: false,
            comments: ""
        },
    })

    const [attachments, setAttachments] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(0);
    const [selectedItemId, setSelectedItemId] = useState(0);
    const [submittalDescription, setSubmittalDescription] = useState("");
    const [briefDescription, setBriefDescription] = useState("");
    const [loadingList, setLoadingList] = useState(false);
    const [inspectionFormData, setInspectionFormData] = useState([]);
    const [inspectionFormID, setinspectionFormID] = useState(0);
    const [consultantData, setConsultantData] = useState([]);
    const [consultantId, setConsultantId] = useState(0);

    const options = [
        { value: 0, label: "Pending" },
        { value: 1, label: 'Approved' },
        { value: 2, label: 'Revise' },
        { value: 3, label: 'Rejected' },
        { value: 4, label: 'In Clearence' }
    ];
    const submittalOptions = [
        "Sub-contractor pre-qualification",
        "Material & product data",
        "Method statement",
        "Design calculation",
        "Request for information",
        "Testing and commissioning",
        "Inspection request",
    ];

    // const handleFileChange = (e) => {
    //     const selectedFiles = Array.from(e.target.files);
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         attachments: [...prevData.attachments, ...selectedFiles]
    //     }));
    //     // add here selected files to attachments and set state
    //     // console.log("Selected Files:", selectedFiles);
    //     setAttachments((prevFiles) => [...prevFiles, ...selectedFiles]);

    //     console.log("Selected Files:", selectedFiles);
    //     e.target.value = "";
    // };

    // const handleRemoveFile = (index) => {
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         attachments: prevData.attachments.filter((_, i) => i !== index)
    //     }));
    // };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFormData((prevData) => ({
            ...prevData,
            attachments: [...prevData.attachments, ...selectedFiles]
        }));

        setAttachments((prevFiles) => [...prevFiles, ...selectedFiles]);
        e.target.value = "";
    };

    const handleRemoveFile = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            attachments: prevData.attachments.filter((_, i) => i !== index)
        }));

        setAttachments((prevFiles) =>
            prevFiles.filter((_, i) => i !== index)
        );
    };

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : '');
    };


    const handleSelect = (selectedOption) => {
        setItemId(selectedOption ? selectedOption.value : null);
        setSelectedItemId(selectedOption ? selectedOption.value : null);
        setSelectedOptions(selectedOption);
    };
    const handleFormSelect = (selectedOption) => {
        setinspectionFormID(selectedOption ? selectedOption.value : null);
    };
    const handleChangeProject = (selectedOption) => {
        setProjectId(selectedOption ? selectedOption.value : null);
        setSelectedOptions(selectedOption);
        GetItemList(selectedOption)
    };

    const handleConsuntantSelect = (selectOption) => {
        setConsultantId(selectOption ? selectOption.value : null);
    };

    const getInspectionForm = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/inspections/GetInspections`, { headers });
            const { data } = response.data;
            setInspectionFormData(
                data.map((row) => ({
                    value: row.inspection_id,
                    label: row.inspection_title
                }))
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getProjectConsultant = async () => {
        try {
            const response = await axios.get(`${apiURL}api/project-consultants/project/${projectId}`);
            const { data, success } = response.data;
            if (success === true) {
                setConsultantData(
                    data.map((row) => ({
                        value: row.consultant_id,
                        label: row.profile_name
                    }))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };


    const Labels = (status) => {
        if (status === 0) {
            return "Pending"
        }
        else if (status === 1) {
            return "Approved"
        }
        else if (status === 2) {
            return "Revise"
        }
        else if (status === 3) {
            return "Rejected"
        }
        else if (status === 4) {
            return "In-Clearence "
        }
    }
    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning"
        }
        else if (status === 1) {
            return "badge bg-success-subtle text-success"
        }
        else if (status === 2) {
            return "badge bg-info-subtle text-info"
        }
        else if (status === 3) {
            return "badge bg-danger-subtle text-danger"
        }
        else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary"
        }
    }

    const AcceptRejectRequest = (actionType) => {
        Swal.fire({
            title: `Submit Remark for ${actionType}`,
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            inputValidator: (value) => {
                if (!value) {
                    return 'Remark cannot be empty';
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // Show success message
                Swal.fire({
                    icon: 'success',
                    title: 'Remark successfully submitted',
                    showConfirmButton: false,
                    timer: 1500, // Auto-close after 1.5 seconds
                }).then(() => {
                    // Update state based on action
                    if (actionType === 'Accept') {
                        setStatus('approved');
                    } else if (actionType === 'Cancel') {
                        setStatus('rejected');
                    }
                });
            }
        });
    };

    const handlePrev = () => {
        if (prev) {
            setPage((prevPage) => prevPage - 1);
        }
    };

    const handleNext = () => {
        if (next) {
            setPage((prevPage) => prevPage + 1);
        }
    };
    const handleChange = (e) => {
        setPage(parseInt(e.target.value, 10));
    };

    const GetAllRequests = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;
            const response = await axios.get(
                `${apiURL}api/GetDashboardForContractor`,
                {
                    params: { contractor_id: user_profile_id },
                    headers,
                }
            );
            const data = response.data
            console.log(response.data?.data?.tabs?.projects_requests, "data");
            if (data.success) {
                setRows(response.data?.data?.tabs?.projects_requests)
                setNext(data.next);
                setPrev(data.prev);
                // setPage(data.page);
                setTotalRecords(data.total_records);
                setTotalPages(data.total_pages);
                setReload(false);
            }


        } catch (error) {
            console.log("error while fetching data", error);

        }
        finally {
            setLoadingList(false)
        }
    }

    const GetProjectData = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/contractors/projects/${user_profile_id}`, {

                headers,
            })

            const { data, success } = response.data;
            console.log(data, "response");
            if (success) {
                setProjectData(data.map((row) => ({
                    value: row.project_id,
                    label: row.project_title
                })))
            }


        } catch (error) {
            console.log("Error while fetching data", error);

        }
    }

    const GetItemList = async (selectedOption) => {
        try {
            const headers = apiHeaderJson
            const response = await axios.get(`${apiURL}api/requests/GetProjectItems`, { params: { project_id: selectedOption } })

            const { data, success } = response.data;
            if (success) {
                setItemRow(data.map((row) => ({
                    value: row.project_item_id,
                    label: row.item_name,
                })))
            }
            else {
                setItemRow([])
            }
        } catch (error) {
            console.log("Error while fetching data", error);

        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Create FormData object
            const formData = new FormData();

            // Append text fields
            formData.append('project_id', projectId);
            formData.append('inspection_id', inspectionFormID);
            formData.append('consultant_id', consultantId)
            formData.append('project_item_id', selectedItemId);
            formData.append('contractor_id', user_profile_id);
            formData.append('submittal_description', submittalDescription);
            formData.append('request_brief_description', briefDescription);

            // Append files
            attachments.forEach((file) => {
                formData.append('attachments[]', file);
            });

            // Make the API request
            const response = await axios.post(
                `${apiURL}api/requests/PostProjectRequest`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            const { success } = response.data;

            // Show success/error message
            Swal.fire({
                title: `<strong>${success ? "Success" : "Failed"}</strong>`,
                text: response.data.message,
                icon: success ? "success" : "error",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            if (success) {
                resetForm();
                // Close modal
                document.getElementById('btn-close-model').click();
                GetAllRequests()
            }

        } catch (error) {
            console.error('Error submitting request:', error);
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to submit request',
                icon: 'error',
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });
        }
    };

    const updateRequest = async (id) => {
        const headers = apiHeaderJson
        const Body = {
            project_request_id: id
        }
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'You want to resubmit the request!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Resubmit it!'
        });
        if (confirm.isConfirmed) {
            try {
                const response = await axios.post(`${apiURL}api/requests/ResubmitRequest`, Body, { headers });
                const { success } = response.data;
                if (success === true) {
                    Swal.fire({
                        title: `<strong>${response.data.success ? "Success" : "Failed"
                            }</strong>`,
                        text: response.data.message,
                        icon: response.data.success ? "success" : "error",
                        timer: 1000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    GetAllRequests();
                }

            } catch (error) {
                console.error(error);
                Swal.fire(
                    'Error!',
                    'Something went wrong while Updating.',
                    'error'
                );

            }
        }
    }


    const handleDownload = (downloadType) => {
        const endpoint = `api/GetDashboardForContractor`;
        const params = {
            contractor_id: user_profile_id
        };

        const columns = [
            { header: "Project Name", width: 30 },
            { header: "Item Name", width: 35 },
            { header: "Submittal Description", width: 27 },
            { header: "Brief Description", width: 30 },
            { header: "Location", width: 30 },
            { header: "Status", width: 25 },
        ];

        const mapRow = (data) => ({
            "Project Name": data?.project_title ?? '-',
            "Item Name": data?.item_name ?? '-',
            "Submittal Description": data?.submittal_description ?? "-",
            "Brief Description": data?.request_brief_description ?? "-",
            "Location": data?.project_address ?? "-",
            "Status": Labels(data?.request_status) ?? "-",
        });

        // Modify the response handling in handleDownloadOptions to get the correct data path
        const responseHandler = (response) => response.data?.data?.tabs?.projects_requests || [];

        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson, responseHandler);
    };

    const resetForm = () => {
        setFormData((prev) => ({ ...prev, attachments: [] }));
        setAttachments([]);
        setItemRow([]);
        setItemId(0);
        setProjectId(0)
        setBriefDescription("");
        setSubmittalDescription("")
        setinspectionFormID(0)
        setConsultantId(0)
        setinspectionFormID(0)
    };

    useEffect(() => {
        GetAllRequests()
        GetProjectData()
        getInspectionForm()
    }, [])

    useEffect(() => {
        projectId && getProjectConsultant();
        console.log(projectId, "Project isddddd")
    }, [projectId])
    return (
        <div className='main-content'>
            <div className='page-content'>
                {
                    loadingList ? <ContentLoader /> :
                        <>
                            <div className="container-fluid">
                                <PageTitle title={`All Requests`} primary={`Home`} />
                                <div className="col-md-12">
                                    <div className="card">
                                        <div
                                            className="card-header align-items-center d-flex justify-content-between"
                                            style={{
                                                background: "#000000",
                                            }}
                                        >
                                            <h4 className="card-title mb-0 flex-grow-1 text-white">Requested List</h4>

                                            <div className="d-flex align-items-center gap-3">


                                                {/* <button
                                                    type="button"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#myModal"
                                                    className="btn btn-warning btn-label waves-effect waves-light"
                                                    onClick={() => getProjectConsultant()}
                                                >
                                                    <i className="ri-add-circle-line label-icon align-middle fs-16 me-2" />
                                                    Add Request
                                                </button> */}

                                            </div>
                                        </div>
                                        <div className="card-header pt-0 pb-0" style={{ border: "none" }}>
                                            <div className="row align-items-center justify-content-end py-3 g-3">
                                                {/* Status Select - takes 4 columns on md screens, full width on mobile */}
                                                {/* <div className="col-md-4 col-12">
                                                    <Select
                                                        options={options}
                                                        value={selectOption ? options.find(option => option.value === selectOption) : null}
                                                        onChange={handleSelectStatus}
                                                        placeholder="Please Select Status"
                                                    />
                                                </div> */}

                                                {/* Spacer - hidden on mobile */}
                                                {/* <div className="col-md-2 d-none d-md-block"></div>

                                                <div className="col-md-3"></div> */}


                                                {/* Download Report Dropdown - takes 3 columns on md screens, full width on mobile */}
                                                <div className="col-md-2">
                                                    <div className="dropdown">
                                                        <button
                                                            type="button"
                                                            className="btn btn-light btn-label waves-effect waves-light"
                                                            id="dropdownMenuLink4"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="true"
                                                        >
                                                            <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                                            Download Report
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                                                            </li>
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                                                                <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                                                                </li>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="card-body">
                                             <div className="table-responsive table-card">
                                                   <table
                                                       className={`table table-bordered table-stripped table-nowrap mb-0`}
                                                   >
                                                       <thead className="table-light">
                                                           <tr>
                                                               <th className="text-center" width="25%">Project Name</th>
                                                               <th className="text-center" width="10%">Item Name</th>
                                                               <th className="text-center" width="25%">Submittal Description</th>
                                                               <th className="text-center" width="25%">Brief Description</th>
                                                               <th className="text-center" width="25%">Location</th>
                                                               <th className="text-center" width="10%">Revision Count</th>
                                                               <th className="text-center" width="20%">Status</th>
                                                               <th className="text-center" width="15%">
                                                                   Action
                                                               </th>
                                                           </tr>
                                                       </thead>
                                                       {rows.length !== 0 ? (
                                                           <tbody>
                                                               {
                                                                   // project_id &&
                                                                   rows.map((row) => (
                                                                       <tr key={row.category_id}>
                                                                           <td className="text-center"><NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title ?? '-'}</NavLink></td>
                                                                           <td className="text-center">{row?.item_name ?? '-'}</td>
                                                                           <td className="text-center">{row?.submittal_description ?? '-'}</td>
                                                                           <td className="text-center">{row?.request_brief_description ?? '-'}</td>
                                                                           <td className="text-center">{row?.project_address}</td>
                                                                           <td className="text-center">{row?.request_revision_count}</td>
                                                                           <td className="text-center"><span className={Classes(row.request_status)}>{Labels(row.request_status)}</span></td>
                                                                           {/* <td className="text-center">Architecture</td> */}
                                                
                                                                           <td className="d-flex justify-content-around">
                                                
                                                
                                                                               {/* Reject Button */}
                                                                               {row.request_status === 0 ? (
                                                                                   <button
                                                                                       onClick={() => AcceptRejectRequest('Cancel')}
                                                                                       type="button"
                                                                                       className="btn btn-outline-secondary btn-sm btn-icon waves-effect waves-light"
                                                                                   >
                                                                                       <i className="  ri-close-line align-middle fs-15 "></i>
                                                                                   </button>
                                                                               ) :
                                                                                   <Link to={`/PreviewStatus/${row?.project_request_id}`}>
                                                                                       <button
                                                                                           type="button"
                                                                                           className="btn btn-link text-info fs-18 p-0"
                                                
                                                                                       >
                                                                                           <i className=" ri-eye-line" />
                                                                                       </button>
                                                                                   </Link>
                                                                               }
                                                                               {row.request_status === 2 &&
                                                
                                                
                                                                                   <button
                                                                                       onClick={() => updateRequest(row?.project_request_id)}
                                                                                       type="button"
                                                                                       className="btn btn-soft-info btn-border fs-10 mx-1"
                                                
                                                                                   >   Resubmit
                                                
                                                                                   </button>
                                                                               }
                                                                           </td>
                                                
                                                                       </tr>
                                                                   ))}
                                                           </tbody>
                                                       ) : (
                                                           <tbody>
                                                               <tr>
                                                                   <td colSpan="8">
                                                                       <NoRecords />
                                                                   </td>
                                                               </tr>
                                                           </tbody>
                                                       )}
                                                       <tfoot className="table-light">
                                                           <tr>
                                                               <th colSpan={8}>
                                                                   <div className="d-flex justify-content-between">
                                                                       <button
                                                                           disabled={
                                                                               prev === false && loadingList === false
                                                                                   ? true
                                                                                   : false
                                                                           }
                                                                           type="button"
                                                                           onClick={() => handlePrev()}
                                                                           className={`btn btn-warning btn-label waves-effect waves-light`}
                                                                       >
                                                                           <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                                                           Previous
                                                                       </button>
                                                                       <div
                                                                           className="col-md-4"
                                                                           style={{
                                                                               display: "flex",
                                                                               alignItems: "center",
                                                                           }}
                                                                       >
                                                                           {
                                                                               <small>
                                                                                   Total Records: {totalRecords} | Total
                                                                                   Pages: {totalPages} | Current Page:{" "}
                                                                                   {page}
                                                                               </small>
                                                                           }
                                                                       </div>
                                                                       <div className="col-md-2">
                                                                           <select
                                                                               className="form-select"
                                                                               onChange={(e) => handleChange(e)}
                                                                           >
                                                                               {Array.from(
                                                                                   { length: totalPages },
                                                                                   (_, i) => (
                                                                                       <option
                                                                                           key={i + 1}
                                                                                           selected={page === i + 1}
                                                                                           value={i + 1}
                                                                                       >
                                                                                           {i + 1}
                                                                                       </option>
                                                                                   )
                                                                               )}
                                                                           </select>
                                                                       </div>
                                                                       <button
                                                                           disabled={
                                                                               next === false && loadingList === false
                                                                                   ? true
                                                                                   : false
                                                                           }
                                                                           type="button"
                                                                           onClick={() => handleNext()}
                                                                           className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                                       >
                                                                           <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                                                           Next
                                                                       </button>
                                                                   </div>
                                                               </th>
                                                           </tr>
                                                       </tfoot>
                                                   </table>
                                             </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div
                                id="myModal"
                                className="modal fade"
                                tabIndex={-1}
                                aria-labelledby="myModalLabel"
                                aria-hidden="true"
                                style={{ display: "none" }}
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="myModalLabel">
                                                Request For New Item
                                            </h5>
                                            <button
                                                type="button"
                                                id="btn-close-model"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                                onClick={() => resetForm()}
                                            >
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="">
                                                    <div className="card shadow-none">
                                                        <div className="row gy-4">
                                                            <div className="col-md-12">
                                                                <form onSubmit={handleSubmit} className="row">
                                                                    <div className="col-md-12 mt-1">
                                                                        <Select
                                                                            onChange={handleChangeProject}
                                                                            options={projectData}
                                                                            placeholder="Please Select Project Name"
                                                                            value={projectId ? projectData.find((option) => option.value === projectId) : null} />
                                                                    </div>

                                                                    {

                                                                        projectId ? <div>

                                                                            <div className="col-md-12 mt-3">
                                                                                <Select
                                                                                    onChange={handleSelect}
                                                                                    options={item_row}
                                                                                    placeholder=" Select Item"
                                                                                    id="setItemError"
                                                                                    value={item_id ? item_row.find((option) => option.value === item_id) : null}
                                                                                />
                                                                            </div>

                                                                            <div className="col-md-12 mt-3">
                                                                                <Select
                                                                                    onChange={handleFormSelect}
                                                                                    options={inspectionFormData}
                                                                                    placeholder="Select Form"
                                                                                    value={inspectionFormID ? inspectionFormData.find(opt => opt.value === inspectionFormID) : null}
                                                                                />
                                                                            </div>


                                                                            <div className="col-md-12 mt-3">
                                                                                <Select
                                                                                    onChange={handleConsuntantSelect}
                                                                                    options={consultantData}
                                                                                    placeholder="Submittal Description"
                                                                                    value={consultantId ? consultantData.find(opt => opt.value === consultantId) : null}
                                                                                />
                                                                            </div>

                                                                            <div className="col-md-12 mt-3">
                                                                                <div className="row">


                                                                                    <div className="col-md-12">
                                                                                        <select className="form-select" onChange={(e) => setSubmittalDescription(e.target.value)} value={submittalDescription}>
                                                                                            <option value="">Type of Submittal</option>
                                                                                            {submittalOptions.map((type, index) => (
                                                                                                <option key={index} value={type}>{type}</option>
                                                                                            ))}
                                                                                        </select>

                                                                                    </div>


                                                                                </div>


                                                                            </div>
                                                                            <div className="col-md-12 mt-3">
                                                                                <div className="row">
                                                                                    <div className="col-md-10">
                                                                                        <input
                                                                                            type="file"
                                                                                            multiple
                                                                                            className="form-control"
                                                                                            onChange={handleFileChange}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-md-2 d-flex justify-content-center align-items-center">
                                                                                        <input
                                                                                            type="file"
                                                                                            id="additionalFileInput"
                                                                                            multiple
                                                                                            className="d-none"
                                                                                            onChange={handleFileChange}
                                                                                        />
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-success btn-sm"
                                                                                            onClick={() => document.getElementById('additionalFileInput').click()}
                                                                                        >
                                                                                            <i className="ri-add-circle-line fs-15"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>

                                                                                {formData.attachments.length > 0 && (
                                                                                    <div className="mt-3 border border p-3 rounded bg-white">
                                                                                        <h6>Uploaded Files:</h6>
                                                                                        <ul className="list-group">
                                                                                            {formData.attachments.map((file, index) => (
                                                                                                <li
                                                                                                    key={index}
                                                                                                    className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                >
                                                                                                    <span>{file.name}</span>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-danger btn-sm"
                                                                                                        onClick={() => handleRemoveFile(index)}
                                                                                                    >
                                                                                                        <i className="ri-delete-bin-line"></i>
                                                                                                    </button>
                                                                                                </li>
                                                                                            ))}
                                                                                        </ul>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className="col-md-12 mt-3">
                                                                                <textarea
                                                                                    id="briefDescription"
                                                                                    name="briefDescription"
                                                                                    value={briefDescription}
                                                                                    onChange={(e) => setBriefDescription(e.target.value)}
                                                                                    rows="3"
                                                                                    className={`form-control `}
                                                                                    placeholder=" Please Enter Breif Descripition   "
                                                                                />
                                                                            </div>

                                                                        </div> : " "
                                                                    }


                                                                </form>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-light"
                                                data-bs-dismiss="modal"
                                                onClick={() => resetForm()}
                                            >
                                                Close
                                            </button>
                                            <button type="button" className="btn btn-primary " disabled={!projectId || !submittalDescription || !item_row || !briefDescription}
                                                onClick={handleSubmit}>
                                                Submit Request
                                                <i className="ri-save-line label-icon align-middle fs-16 ms-2"></i>

                                            </button>
                                        </div>
                                    </div>
                                    {/* /.modal-content */}
                                </div>
                                {/* /.modal-dialog */}
                            </div>
                        </>
                }

            </div>
        </div >
    )
}

export default AllRequests